import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";
import MenuButton from "./MenuButton";

import { NavData } from "./NavData";
import { NavLink, useParams,useNavigate } from "react-router-dom";
import { createPartner, getAllPartners } from "../../api/axios";
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import validator from "validator";
import { Formik } from "formik";
import * as Yup from "yup";
import { showToast } from "../../Utills/toast";
import FormGroup from "../Common/FormGroup";
import { Form } from "react-bootstrap";
import PhoneNumberInput from "../Common/PhoneInput/PhoneNumberInput";
import { IoEyeOffSharp, IoEyeSharp } from "react-icons/io5";
import LoadingDots from "../Common/LoadingDots/LoadingDots";

// Validation Schema
const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .trim()
    .required("First name is required."),
  last_name: Yup.string()
    .trim()
    .required("Last name is required."),
  email: Yup.string()
    .email("A valid email is required.")
    .required("Email is required."),
  phone_number: Yup.string(),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters long.")
    .required("Password is required."),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], "Passwords do not match.")
    .required("Confirm password is required."),
  sub_domain: Yup.string()
    .trim()
    .required("Subdomain is required."),
  logo: Yup.mixed()
    .required("Logo is required."),
});

const initialFormState = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  password: "",
  confirmPassword: "",
  sub_domain: "",
  logo: null,
};

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();
  const [isSubCategoriesOpen, setIsSubCategoriesOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedPartnerId, setSelectedPartnerId] = useState(0);
  const navigate = useNavigate();
  const [dropdownData, setDropdownData] = useState();
  const [saving, setSaving] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  
  const tooltipRef = useRef();
  const { partnerId } = useParams();

  useEffect(() => {
    if (partnerId) {
      setSelectedPartnerId(partnerId);
    }
  }, [partnerId]);

  function handleClick(event) {
    setIsOpen(!isOpen);
    event.preventDefault();
  }
  function handleClickOutside(event) {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      !tooltipRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    return () => {};
  }, []);

  const handleFormSubmit = async (values, { setSubmitting, setFieldError, resetForm }) => {
    const formDataToSend = new FormData();

    // Append each field from values to formDataToSend
    for (const key in values) {
      if (values[key] !== null && values[key] !== undefined) {
        formDataToSend.append(key, values[key]);
      }
    }

    setSaving(true);
    setSubmitting(true);

    try {
      const res = await createPartner(formDataToSend);

      if (res.status === 200) {
        handleDialogClose();
        resetForm();
        showToast({
          type: 'success',
          message: res?.data?.message || 'Partner created successfully!',
        });
        // Refresh the dropdown data
        fetchAllPartner();
      }
    } catch (err) {
      setFieldError('general', 
        err?.response?.data?.message ||
        "Something went wrong! Please try again later"
      );
    } finally {
      setSaving(false);
      setSubmitting(false);
    }
  };

  const fetchAllPartner = async () => {
    try {
      setLoading(true);
      const response = await getAllPartners();
      const partnerData = response?.data?.data;

      let dropdownData = partnerData?.map((partner) => {
        return { title: partner?.sub_domain, value: partner?.id };
      });

      setDropdownData(dropdownData);
    } catch (error) {
      console.log(error);
      showToast({
        type: 'error',
        message: error?.response?.data?.message || 'Something went wrong! Please try again later',
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAllPartner();
  }, []);

  function handleCategoryClick(event) {
    setIsSubCategoriesOpen(!isSubCategoriesOpen);
  }
  const handleSelectChange = (e) => {
    const { value } = e.target;
    if (!value || value === "0") {
      navigate(`/home`);
      return;
    }
    if (value === "insert") {
      setDialogOpen(true);
      return;
    }
    setSelectedPartnerId(value);
    navigate(`/${value}/general-settings`);
    setIsOpen(false);
  };

  return (
    <div>
      <Wrapper>
        <img
          alt="logo"
          // onClick={() => {
          //   navigate("https://www.pawprintid.com/");
          // }}
          src={require("../../Assets/pawprint-icon.png")}
        />
        <MenuWrapper>
          <HamburgerWrapper onClick={(event) => handleClick(event)} ref={ref}>
            <MenuButton
              item={{
                icon: require("../../Assets/hamburger-menu.png"),
              }}
            />
          </HamburgerWrapper>
        </MenuWrapper>
      </Wrapper>
      <div ref={tooltipRef}></div>
      <SmallScreenWrapper isOpen={isOpen}>
        {partnerId && NavData.map((item,index) => (
             <NavLink
             to={`/${partnerId}${item.link}`}
             onClick={() => setIsOpen(false)}
             key={index}
               style={{textDecoration: "none",paddingBottom:5}}
               >
          <MenuButton key={item?.id} item={item} />
          </NavLink>
        ))}
         {/* <div onClick={(event) => handleCategoryClick(event)} className="text-white text-center">Select partner</div> */}
        <SelectBox
          onChange={(e) => {
            const { value } = e.target;
            if (value === "insert") {
              setDialogOpen(true); 
              e.target.value = partnerId || 0;
            } else {
              handleSelectChange(e);
            }
          }}
        >
          <option value={0} selected={false}>
                {loading ? (
                  <>
                    Fetching partners
                    <LoadingDots speed={200} maxDots={3} color="inherit" size="inherit" />
                  </>
                ) : (
                  "Select the partner"
                )}
          </option>
          {dropdownData?.map((option, index) => (
            <option
              style={{backgroundColor:'#FFF'}}
              key={index}
              value={option.value}
              selected={option.value === Number(selectedPartnerId)}
            >
              {option?.title}
            </option>
          ))}
          <option key={"insert"} value={"insert"} selected={false}>
            + Add Partner
          </option>
        </SelectBox>
      </SmallScreenWrapper>
       <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Add New Partner</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={initialFormState}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              getFieldProps,
            }) => (
              <form onSubmit={handleSubmit}>
                <FormGroup label="First Name" error={touched.first_name && errors.first_name} requiredField>
                  <Form.Control
                    {...getFieldProps('first_name')}
                    type="text"
                    placeholder="Enter First Name"
                  />
                </FormGroup>

                <FormGroup label="Last Name" error={touched.last_name && errors.last_name} requiredField>
                  <Form.Control
                    {...getFieldProps('last_name')}
                    type="text"
                    placeholder="Enter Last Name"
                  />
                </FormGroup>

                <FormGroup label="Email" error={touched.email && errors.email} requiredField>
                  <Form.Control
                    {...getFieldProps('email')}
                    type="email"
                  />
                </FormGroup>

                <FormGroup label="Phone Number">
                  <PhoneNumberInput
                    label='Phone Number'
                    name="phone_number"
                    value={values.phone_number}
                    error={touched.phone_number && !!errors.phone_number}
                    onChange={(value, country) => {
                      setFieldValue('phone_number', value);
                    }}
                  />
                </FormGroup>

                <FormGroup label="Password" error={touched.password && errors.password} requiredField>
                  <div style={{ position: 'relative' }}>
                    <Form.Control
                      {...getFieldProps('password')}
                      type={showPassword ? "text" : "password"}
                    />
                    <button
                      type="button"
                      style={{
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '14px'
                      }}
                      className="w-auto m-0 cursor-pointer position-absolute"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <IoEyeOffSharp size={20} /> : <IoEyeSharp size={20} />}
                    </button>
                  </div>
                </FormGroup>

                <FormGroup label="Confirm Password" error={touched.confirmPassword && errors.confirmPassword} requiredField>
                  <div style={{ position: 'relative' }}>
                    <Form.Control
                      {...getFieldProps('confirmPassword')}
                      type={showConfirmPassword ? "text" : "password"}
                    />
                    <button
                      type="button"
                      style={{
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        fontSize: '14px',
                      }}
                      className="w-auto m-0 cursor-pointer position-absolute"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? <IoEyeOffSharp size={20} /> : <IoEyeSharp size={20} />}
                    </button>
                  </div>
                </FormGroup>

                <FormGroup label="Subdomain" error={touched.sub_domain && errors.sub_domain} requiredField>
                  <Form.Control
                    {...getFieldProps('sub_domain')}
                    type="text"
                  />
                </FormGroup>

                <ThemeLogo>
                  {values?.logo && typeof values?.logo !== "string" ? (
                    <Box
                      component="div"
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <img
                        style={{
                          maxWidth: "13vw",
                          cursor: "pointer",
                          borderRadius: "8px",
                        }}
                        src={URL.createObjectURL(values?.logo)}
                        alt="image1"
                        onMouseEnter={(e) => {
                          e.target.style.opacity = 0.8;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.opacity = 1;
                        }}
                      />
                    </Box>
                  ) : values?.logo ? (
                    <Box
                      component="div"
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <img
                        style={{
                          maxWidth: "13vw",
                          cursor: "pointer",
                          borderRadius: "8px",
                        }}
                        src={values?.logo}
                        alt="image1"
                        onMouseEnter={(e) => {
                          e.target.style.opacity = 0.8;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.opacity = 1;
                        }}
                      />
                    </Box>
                  ) : (
                    ""
                  )}
                  <Button variant="contained" component="label" fullWidth sx={{backgroundColor:'rgb(252,132,51)'}}>
                    Upload Logo
                    <input 
                      type="file" 
                      name="logo" 
                      onChange={(event) => {
                        setFieldValue("logo", event.currentTarget.files[0]);
                      }}
                      hidden 
                    />
                  </Button>
                </ThemeLogo>
                {touched.logo && errors.logo && (
                  <p style={{ color: "#dc3545", fontSize: "12px", fontWeight: "400" }}>
                    {errors.logo}
                  </p>
                )}

                {errors.general && (
                  <p style={{ color: "#dc3545", fontSize: "12px", fontWeight: "400" }}>
                    {errors.general}
                  </p>
                )}

                <DialogActions>
                  <Button onClick={handleDialogClose} color="error">
                    Cancel
                  </Button>
                  <Button type="submit" color="primary" disabled={isSubmitting || saving}>
                    {isSubmitting || saving ? 'Submitting...' : 'Submit'}
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}

const HamburgerWrapper = styled.div`
  display: none;
  @media (max-width: 890px) {
    display: block;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 150px;
  position: fixed;
  display: grid;
  gap: 200px;
  grid-template-columns: 10px auto;
  justify-content: space-around;
  align-items: center;
  background: #ff8533;
  z-index: 100;
  display: none;

  @media (max-width: 890px) {
    display: grid;
    gap: 300px;
    grid-template-columns: 10px auto;
    justify-content: space-around;
    height: 120px;
    position: relative;
  }
  @media (max-width: 350px) {
    gap: 200px;
  }
`;

const MenuWrapper = styled.div`
  align-items: center;
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(8, auto);

  @media (max-width: 1130px) {
    > a {
      display: none;
    }
    grid-template-columns: auto;
  }
  .active {
    background: #ff8533;
    border-radius: 10px;
    padding: 10px 15px;
  }

  a {
    text-decoration: none;
  }
`;

const SmallScreenWrapper = styled.div`
  display: none;
  @media (max-width: 890px) {
    display: block;
    position: fixed;
    top: 77px;
    right: 6px;
    background: rgba(15, 14, 71, 0.3);
    box-shadow: 0px 50px 100px rgba(0, 0, 0, 0.25),
      inset 0px 0px 0px 0.5px rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(40px);
    border-radius: 20px;
    padding: 10px;
    opacity: ${(props) => (props.isOpen ? 1 : 0)};
    visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
    z-index: 1111;
    display: grid;
    gap: 1px;
    grid-template-columns: 200px;
    transition: 0.3s ease-in-out;
    overflow-y: auto;
    max-height: 80vh;
  }
`;
const SelectBox = styled.select`
  width: 100%;
  height: 45px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  background: transparent;
  outline: none;
  border: 0;
  padding: 0;
  text-align: center;
  color: #FFF;
`;
const ThemeLogo = styled.div`
border: 1px solid #d1d5db;
width: 100%;
padding: 10px;
margin: 10px 12px;
border-radius: 10px;
background-color: #f2f2f2;
max-width: fit-content;
img {
  margin-bottom: 23px;
}
`;